
















import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { getUrlParams } from '@/utils/urlUtils'
import { sa } from '@/utils/sa'

@Component
export default class LabelContainer extends Vue {
  public tags = []
  public get factors() {
    return this.$store.state.question.factors
  }
  public get subject() {
    return this.$store.state.subject
  }
  public get activeKey() {
    return this.$store.state.question.bookorkps
  }
  @Watch('factors', { deep: true })
  onFactorsChange(val) {
    let arr: any = []
    this.tags = val.checked

    // 打点逻辑
    if (!val.checked) return
    if (!val.checked.length) return
    for (let n of val.checked) {
      let name = this.getName(n)
      arr = [...arr, name]
    }
    // setTimeout(() => {
    //   window['sensors'].track('ContentRepository_Top', {
    //     lvevl1Menu: this.subject.label,
    //     lvevl2Menu: '知识点',
    //     lvevl3Menu: arr
    //   })
    // }, 50)
  }
  /**
   * getName
   */
  public getName(item) {
    let res = getUrlParams(item)
    return res ? res.title : ''
  }
  public onClose(item) {
    const tags = this.tags.filter((tag) => tag !== item)
    // 状态传递
    this.$store.commit('SET_FACTORS', {
      checked: tags,
      halfChecked: []
    })
  }
}
